import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import CustomDropdown from '../../components/Inputs/CustomDropdown';
import practiceConstants from './practiceConstants';

export default class CategoriesDetal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: true,
    };
  }

  static propTypes = {
    selectedCategory: PropTypes.object.isRequired,
    onChangeSort: PropTypes.func.isRequired,
  };

  handleSelectedSearchChange = (item) => {
    this.props.onChangeSort(item);
  };

  handleOnClick = () => {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen,
    }));
  };

  render() {
    const { selectedCategory, selectedSort } = this.props;

    if (!selectedCategory) {
      return <React.Fragment />;
    }

    return (
      <div
        className={classnames('box-content', 'collpse-box', { '-collapse': !this.state.isOpen })}
      >
        <div className="dropdown-practice-sort">
          <span className="dropdown-practice-sort-text">Cортировать по </span>
          <CustomDropdown
            className="custom-dropdown--sort"
            categories={practiceConstants.sortTypes}
            selected={selectedSort}
            placeholder="Выберите вид сортировки"
            onChange={this.handleSelectedSearchChange}
          />
        </div>

        <h2 className="collpse-box-title">{selectedCategory.title}</h2>

        <div
          className={classnames('collpse-box-btn', {
            hidden: !this.props.selectedCategory.description,
          })}
          onClick={this.handleOnClick}
        />

            {selectedCategory.description ? (
                <div className="collpse-box-content" dangerouslySetInnerHTML={{ __html: selectedCategory.description }}></div>
        ) : (
          ''
        )}
      </div>
    );
  }
}
